import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      isLandscape: state => state.page.isLandscape
    }),
    tranName() {
      return this.isLandscape ? 'fade' : 'slide-up';
    }
  }
};
